export default "__VITE_ASSET__CScw0Ir4__"